<template>
  <router-view />
  <BaseNotifications></BaseNotifications>
</template>

<script setup lang="tsx">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { BaseNotifications } from "@modernary/mui/components/notifications";
import { useAppNav } from "@modernary/mui/components/common";

import { routeNames } from "@/routes";

const route = useRoute();
const { setNavigationItems, setApplicationTitleComponent } = useAppNav();

const titleComponent = () => <div class="ml-3 font-bold text-neutral-500 md:ml-4 md:text-xl">SMART</div>;
setApplicationTitleComponent(titleComponent);

// Nav items should be set one time during app initilization / config.
setNavigationItems([
  {
    label: "home",
    className: "",
    showLabel: false,
    items: [
      { label: "Home", name: routeNames.home },
      { label: "Complaints", name: routeNames.complaint.complaints },
      { label: "Contacts", name: routeNames.person.persons },
    ],
  },
  {
    label: "Solid Waste",
    className: "", //break-before-column
    items: [
      { label: "Applications", name: routeNames.application.applications },
      { label: "Disposal Reports", name: routeNames.disposalReport.disposalReports },
      { label: "Facilities", name: routeNames.facilitySite.facilitySites },
      { label: "Inspections", name: routeNames.inspection.inspections },
      { label: "Permits", name: routeNames.permit.permits },
      { label: "Permit Versions", name: routeNames.permitVersion.permitVersions },
      { label: "Reports", name: routeNames.report.reports },
      {
        label: "Facility Data Export",
        name: routeNames.analytics.exportFacilityData,
      },
      {
        label: "Generated Waste Report",
        name: routeNames.analytics.generatedWasteReport,
      },
      {
        label: "Diverted Waste Report",
        name: routeNames.analytics.divertedWasteReport,
      },
      {
        label: "Disposal Report Data Export",
        name: routeNames.analytics.exportDisposalReportData,
      },
    ],
  },
  {
    label: "Sustainability",
    className: "",
    items: [
      { label: "Organizations", name: routeNames.organization.organizations },
      { label: "Recycling Reports", name: routeNames.recyclingReport.recyclingReports },
      { label: "SWMP", name: routeNames.swmp.swmps },
      {
        label: "Diverted Material Report",
        name: routeNames.analytics.divertedMaterialReport,
      },
      {
        label: "Material Category Report",
        name: routeNames.analytics.materialCategoryReport,
      },
      {
        label: "Organization Material Report",
        name: routeNames.analytics.organizationMaterialReport,
      },
      {
        label: "Recycled Material Report",
        name: routeNames.analytics.recycledMaterialReport,
      },
      {
        label: "Recycling Rate Report",
        name: routeNames.analytics.recyclingRateReport,
      },
      {
        label: "Recycling Report Data Export",
        name: routeNames.analytics.exportRecyclingReportData,
      },
      {
        label: "Email List Report",
        name: routeNames.analytics.emailList,
      },
    ],
  },
]);
</script>
